import { React } from 'react';
// import Slider from 'react-slick';
// import { HotOffersCard } from 'components';
// import { Images } from 'assets/images/';
import {
  // Airline,
  HotOffersBlock,
  // HotOffersCardWrapper,
  HotOfferSectionContainer,
  // HotOffersTitle,
  // HotOffersWrapper,
  // HotTitleWrapper,
  // LogoHotOffers,
  // SliderInfo,
} from './styled';

export const HotOffersSection = () => (
  // { popularDestination }
  // TO DO
  // const settings = {
  //   dots: true,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         dots: false,
  //         infinite: false,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         initialSlide: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       },
  //     },
  //   ],
  // };

  <HotOfferSectionContainer>
    <HotOffersBlock>
      {/*<HotOffersWrapper>*/}
      {/*  <HotTitleWrapper>*/}
      {/*    <LogoHotOffers src={Images.logoHotOffer} alt="icon" />*/}
      {/*    <HotOffersTitle>*/}
      {/*      Our*/}
      {/*      <span> Hot offers</span>*/}
      {/*      <HotOffersTitle>for you</HotOffersTitle>*/}
      {/*    </HotOffersTitle>*/}
      {/*  </HotTitleWrapper>*/}

      {/*  <Airline src={Images.popularLine} alt="airline" />*/}

      {/*  <SliderInfo>*/}
      {/*    <Slider {...settings}>*/}
      {/*      {popularDestination.map((item, index) => (*/}
      {/*        <HotOffersCardWrapper key={index}>*/}
      {/*          <HotOffersCard item={item} bgImage={Images.popularPlaceBail} />*/}
      {/*        </HotOffersCardWrapper>*/}
      {/*      ))}*/}
      {/*    </Slider>*/}
      {/*  </SliderInfo>*/}
      {/*</HotOffersWrapper>*/}
    </HotOffersBlock>
  </HotOfferSectionContainer>
);
